import { useParams } from "react-router-dom";

export const useDecodedParams = () => {
  const params = useParams();
  let decodedParams = {};
  for (let key in params) {
    decodedParams[key] = decodeURIComponent(params[key]);
  }
  return decodedParams;
};

export const useSetLanguage = () =>{
  const setLanguage = ( language) => {
    window.localStorage.setItem("language", JSON.stringify({ language}));
    return true;
  };
  const getLanguage = () =>{
    const lang =JSON.parse(window.localStorage.getItem("language"))?.language;
    return lang || 'zh';
  }


  return {setLanguage,getLanguage}
}

export const useSetMember= () =>{
  const setMember = ( memberType) => {
    window.localStorage.setItem("memberType", JSON.stringify({ memberType}));
    return true;
  };
  const getMember = () =>{
    const member =JSON.parse(window.localStorage.getItem("memberType"))?.memberType;
    return member || 'nonmember';
  }
  return {setMember,getMember}
}